<template>
    <!--我要委托-->
    <div class="entrust">
        <div class="info">
            <!--我要出租 -->
            <div class="rent_out">
                <ul class="rent_box">
                    <li class="items box" :class="getName">
                        <div class="name">
                            <span>房主姓名：</span>
                            <input type="text" v-model="List.name" placeholder="请输入房主姓名">
                            <span>{{ mesName }}</span>
                        </div>
                        <div class="select">
                            <div class="select_title">性别：</div>
                            <select v-model="List.sex" class="select_items">
                                <option :value="item.value" v-for="item in gender">{{ item.value }}
                                </option>
                            </select>
                            <i class="iconfont">&#xe619;</i>
                        </div>
                    </li>
                    <li class="items" :class="getCity">
                        <span>所在城市：</span>
                        <input type="text" placeholder="请输入城市名称" v-model="List.shi">
                        <span>{{ mesCity }}</span>
                    </li>
                    <li class="items" :class="getXiaoqu">
                        <span>小区名称：</span>
                        <input type="text" placeholder="请输入小区名称" v-model="List.xiaoqu">
                        <span>{{ mesXiaoQu }}</span>
                    </li>
                    <li class="items" :class="getbuilding">
                        <span>楼栋号：</span>
                        <input type="text" placeholder="请输入楼栋号" v-model="List.building">
                        <span>{{ mesBuilding }}</span>
                    </li>
                    <li class="items" :class="getRoom">
                        <span>房号：</span>
                        <input type="text" placeholder="请输入房号" v-model="List.room_num">
                        <span>{{ mesRoom }}</span>
                    </li>
                </ul>
                <div class='drop_down'>
                    <span class="drop_down_title">户型</span>
                    <div class="select_list">
                        <div class="select">
                            <select v-model="List.room" class="select_items">
                                <option :value="item.id" v-for="item in bedroom">{{ item.value }}
                                </option>
                            </select>
                            <i class="iconfont">&#xe619;</i>
                        </div>
                        <div class="select">
                            <select v-model="List.hall" class="select_items">
                                <option :value="item.id" v-for="item in lobby">{{ item.value }}
                                </option>
                            </select>
                            <i class="iconfont">&#xe619;</i>
                        </div>
                        <div class="select">
                            <select v-model="List.kitchen" class="select_items">
                                <option :value="item.id" v-for="item in kitchen">{{ item.value }}
                                </option>
                            </select>
                            <i class="iconfont">&#xe619;</i>
                        </div>
                        <div class="select">
                            <select v-model="List.toilet" class="select_items">
                                <option :value="item.id" v-for="item in toilet">{{ item.value }}
                                </option>
                            </select>
                            <i class="iconfont">&#xe619;</i>
                        </div>
                    </div>
                </div>
                <ul class="rent_box">
                    <li class="items" :class="getArea">
                        <span>面积：</span>
                        <input type="text" placeholder="请输入您的房屋面积" v-model="List.acreage">
                        <span>{{ mesArea }}</span>
                    </li>
                    <li class="items" :class="getPhone">
                        <span>手机号码：</span>
                        <input type="text" placeholder="请输入您的手机号" v-model="List.phone">
                        <span class="message">{{ msgphone }}</span>
                    </li>

                </ul>
                <div class="code" :class="getCode">
                    <div class="code_box">
                        <span>验证码：</span>
                        <input type="text" v-model="List.sale_code" placeholder="请输入验证码">
                        <span>{{ mesCode }}</span>
                    </div>
                    <button class="btn1" @click="getRentCode()" v-show="ISFS">{{ codeRentMsg }}</button>
                    <button class="btn1 btn2" v-show="!ISFS">{{ codeRentMsg }}</button>
                </div>
                <button type='button' class="btn" @click="submitRent()">提交委托</button>
            </div>

        </div>
    </div>
</template>

<script type="text/ecmascript-6">

	export default {
		data() {
			return {
				//出租
				List: {
					shi: '',
					name: '',
					sex: '先生',
					xiaoqu: '',
					building: '',
					room_num: '',
					room: '1',
					hall: '1',
					kitchen: '1',
					toilet: '1',
					acreage: '',
					phone: '',
					sale_code: '',//验证码
					type: 2,
					token: ''
				},
				tabView: 'select0',//默认显示个人资料
				mesName: '',
				msgphone: '',
				mesCity: '',
				mesXiaoQu: '',
				mesBuilding: '',
				mesRoom: '',
				mesArea: "",
				mesCode: '',
				curNav: 0,
				nav: [{value: '我要卖房'}, {value: '我要出租'}, {value: '我要买房'}, {value: '我要租房'},],
				gender: [{value: '先生', id: '0'}, {value: '女士', id: '1'}],
				bedroom: [{value: '0室', id: '0'}, {value: '1室', id: '1'}, {value: '2室', id: '2'},
					{value: '3室', id: '3'}, {value: '4室', id: '4'}],
				lobby: [{value: '0厅', id: '0'}, {value: '1厅', id: '1'}, {value: '2厅', id: '2'},
					{value: '3厅', id: '3'}, {value: '4厅', id: '4'}],
				kitchen: [{value: '0厨', id: '0'}, {value: '1厨', id: '1'}, {value: '2厨', id: '2'},
					{value: '3厨', id: '3'}, {value: '4厨', id: '4'}],
				toilet: [{value: '0卫', id: '0'}, {value: '1卫', id: '1'}, {value: '2卫', id: '2'},
					{value: '3卫', id: '3'}, {value: '4卫', id: '4'}],
				codeRentMsg: "获取验证码",
				ISFS: true, //是否发送  true 默认是可以发送
				YiFa: false,//已发的样式

			};
		},
		components: {},
		created() {
			// console.log(this.List.type)
			if (localStorage.getItem('isLogin') === '1') {
				this.List.token = localStorage.getItem('token')
			}
		},
		methods: {

			//提交
			submitRent() {
				//提交出租
				// console.log(this.List.type)
				if (this.List.name === '') {
					this.mesName = '请输入姓名'
				} else if (this.List.shi === '') {
					this.mesCity = '请输入城市名称'
				} else if (this.List.xiaoqu === '') {
					this.mesXiaoQu = '请输入小区名称'
				} else if (this.List.building === '') {
					this.mesBuilding = '请输入楼栋号'
				} else if (this.List.room_num === '') {
					this.mesRoom = '请输入房号'
				} else if (this.List.acreage === '') {
					this.mesArea = '请输入面积'
				} else if (this.List.sale_code === '') {
					this.mesCode = '请输入验证码'
				} else {
					this.$api.setSaleHouse(
						this.List
					).then(res => {
						// console.log(res)
						if (res.code === 0) {
							// this.List = {}
							this.$message({
								message: res.msg,
								type: 'success'
							});
						} else {
							this.$message({
								message: res.msg,
								type: 'warning'
							});
						}

					}).catch(err => {
						this.$message({
							message: err.msg,
							type: 'warning'
						});
					})

				}
			},
			//委托验证码
			getRentCode() {
				let regTel = /^\d{11}$/g;
				if (this.List.phone === '') {
					this.msgphone = "手机号不能为空";
				} else if (!regTel.test(this.List.phone)) {
					this.msgphone = ('手机号格式不正确')
				} else if (this.ISFS === true) {
					this.codeTiming();
				} else {
					this.$message({
						message: '请稍后再试',
					});
				}
			},
			// 获取验证码
			codeTiming() {
				let _this = this;
				this.$api.getSaleCode({
					phone: this.List.phone,
					token: this.List.token
				}).then(result => {
					// console.log(result);
					_this.ISFS = false; //更改为不可以发送
					_this.YiFa = true;//更改为不可选的按钮
					if (result.code === 0) {
						let times = 60;
						let dinshiqi = setInterval(function () {
							times--;
							_this.codeRentMsg = times + "s" + "后重新获取";
							if (times < 1) {
								clearInterval(dinshiqi);
								_this.ISFS = true;
								_this.codeRentMsg = "获取验证码"
								_this.YiFa = false
							}
						}, 1000);
					}
					else {
						this.mesCode = result.msg
					}
				}).catch(err => {
					this.mesCode = err.msg
				})
			},
		}
		,
		computed: {
			//提示去除
			getName() {
				if (this.List.name !== '') {
					this.mesName = ''
				}
			}
			,
			getCity() {
				if (this.List.shi !== '') {
					this.mesCity = ''
				}
			}
			,
			getXiaoqu() {
				if (this.List.xiaoqu !== '') {
					this.mesXiaoQu = ''
				}
			}
			,
			getbuilding() {
				if (this.List.building !== '') {
					this.mesBuilding = ''
				}
			}
			,
			getRoom() {
				if (this.List.room_num !== '') {
					this.mesRoom = ''
				}
			}
			,
			getArea() {
				if (this.List.acreage !== '') {
					this.mesArea = ''
				}
			}
			,
			getPhone() {
				if (this.List.phone !== '') {
					this.msgphone = ''
				}
			}
			,
			getCode() {
				if (this.List.sale_code !== '') {
					this.mesCode = ''
				}
			}
			,
		}
	}
</script>

<style lang="less" rel="stylesheet/less" scoped>
    @import "entrust";
</style>